var _path, _rect, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMusicalNote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.92307 20.3809C5.53744 20.3809 6.84614 19.0723 6.84614 17.4579C6.84614 15.8436 5.53744 14.5348 3.92307 14.5348C2.3087 14.5348 1 15.8436 1 17.4579C1 19.0723 2.3087 20.3809 3.92307 20.3809Z",
    fill: "#00D1D2",
    stroke: "#34303D",
    strokeWidth: 1.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.58252,
    y: 5.40242,
    width: 13.2522,
    height: 3.57418,
    transform: "rotate(-15 6.58252 5.40242)",
    fill: "#00D1D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0768 16.7271C18.6912 16.7271 19.9999 15.4184 19.9999 13.804C19.9999 12.1896 18.6912 10.8809 17.0768 10.8809C15.4624 10.8809 14.1537 12.1896 14.1537 13.804C14.1537 15.4184 15.4624 16.7271 17.0768 16.7271Z",
    fill: "#00D1D2",
    stroke: "#34303D",
    strokeWidth: 1.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 13.8042V2.34573C19.9994 2.2339 19.9731 2.12373 19.9231 2.02366C19.8733 1.92359 19.8011 1.83632 19.7121 1.76855C19.6232 1.70078 19.5199 1.65433 19.4101 1.63277C19.3003 1.61121 19.1872 1.61512 19.0792 1.64419L7.38693 4.8888C7.23242 4.93041 7.09583 5.02157 6.99815 5.14829C6.90046 5.27504 6.84705 5.43033 6.84616 5.59034V17.4581",
    stroke: "#34303D",
    strokeWidth: 1.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.84616 9.41947L20 5.76563",
    stroke: "#34303D",
    strokeWidth: 1.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicalNote);
export default __webpack_public_path__ + "static/media/musicalNote.eefa9c341702d0c16f14de1e041bd8bd.svg";
export { ForwardRef as ReactComponent };